import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;

function getAdminToken() {
  return localStorage.getItem('admin_jwt');
}

export default {
  saveToken(token) {
    localStorage.setItem('admin_jwt', token);
  },

  clearToken() {
    localStorage.removeItem('admin_jwt');
  },

  getDecodedToken() {
    const token = getAdminToken();
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp < Date.now() / 1000) {
        this.clearToken();

        return null;
      }

      return payload;
    } catch {
      return null;
    }
  },

  isAuthenticated() {
    const decoded = this.getDecodedToken();

    return !!(decoded && decoded.isAdmin);
  },

  async login(email, password) {
    const response = await axios.post(apiUrl + '/v1/auth/login', {
      email,
      password,
      issuer: 'a1connect',
    });

    return response.data.sessionJwt;
  },

  async triggerSync() {
    const response = await axios.post(
      apiUrl + '/v1/admin/etablissements/sync',
      {},
      {
        headers: { Authorization: `Bearer ${getAdminToken()}` },
      },
    );

    return response.data;
  },

  async getInseeRemaining() {
    const response = await axios.get(apiUrl + '/v1/admin/etablissements/sync/insee/remaining', {
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });

    return response.data;
  },

  async getInseeNotFoundCount() {
    const response = await axios.get(apiUrl + '/v1/admin/etablissements/sync/insee/not-found', {
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });

    return response.data;
  },

  async triggerInseeSync() {
    const response = await axios.post(
      apiUrl + '/v1/admin/etablissements/sync/insee',
      {},
      {
        headers: { Authorization: `Bearer ${getAdminToken()}` },
      },
    );

    return response.data;
  },

  async triggerFlagsSync() {
    const response = await axios.post(
      apiUrl + '/v1/admin/etablissements/sync/flags',
      {},
      {
        headers: { Authorization: `Bearer ${getAdminToken()}` },
      },
    );

    return response.data;
  },

  async triggerInseeNotFoundRetry() {
    const response = await axios.post(
      apiUrl + '/v1/admin/etablissements/sync/insee/not-found',
      {},
      {
        headers: { Authorization: `Bearer ${getAdminToken()}` },
      },
    );

    return response.data;
  },

  async getCommunesIndexStatus() {
    const response = await axios.get(apiUrl + '/v1/admin/etablissements/communes-index/status', {
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });

    return response.data;
  },

  async triggerCommunesIndexRefresh() {
    const response = await axios.post(
      apiUrl + '/v1/admin/etablissements/communes-index/refresh',
      {},
      {
        headers: { Authorization: `Bearer ${getAdminToken()}` },
      },
    );

    return response.data;
  },

  async fetchEtablissementsFilterOptions() {
    const response = await axios.get(apiUrl + '/v1/admin/etablissements/filter-options', {
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });

    return response.data;
  },

  async fetchEtablissements({
    q,
    departement,
    type,
    ministere,
    niveauEnseignement,
    formation,
    formationType,
    zrr,
    qpv,
    hasIps,
    hasIel,
    estEncorde,
    selectif,
    estCampusConnecte,
    isPrioritaire,
    isMVLSPartenaire,
    isPrioritaireIndiceIel,
    isPrioritaireIndiceIps,
    page,
    limit,
  } = {}) {
    const params = { page, limit };
    if (q) params.q = q;
    if (departement) params.departement = departement;
    if (type) params.type = type;
    if (ministere) params.ministere = ministere;
    if (niveauEnseignement) params.niveauEnseignement = niveauEnseignement;
    if (formation) params.formation = formation;
    if (formationType) params.formationType = formationType;
    if (zrr !== undefined) params.zrr = zrr;
    if (qpv !== undefined) params.qpv = qpv;
    if (hasIps !== undefined) params.hasIps = hasIps;
    if (hasIel !== undefined) params.hasIel = hasIel;
    if (estEncorde !== undefined) params.estEncorde = estEncorde;
    if (selectif !== undefined) params.selectif = selectif;
    if (estCampusConnecte !== undefined) params.estCampusConnecte = estCampusConnecte;
    if (isPrioritaire !== undefined) params.isPrioritaire = isPrioritaire;
    if (isMVLSPartenaire !== undefined) params.isMVLSPartenaire = isMVLSPartenaire;
    if (isPrioritaireIndiceIel !== undefined) params.isPrioritaireIndiceIel = isPrioritaireIndiceIel;
    if (isPrioritaireIndiceIps !== undefined) params.isPrioritaireIndiceIps = isPrioritaireIndiceIps;

    const response = await axios.get(apiUrl + '/v1/admin/etablissements', {
      params,
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });

    return response.data;
  },

  async patchEtablissement(id, data) {
    const response = await axios.patch(apiUrl + `/v1/admin/etablissements/${id}`, data, {
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });

    return response.data;
  },

  async createEtablissement(data) {
    const response = await axios.post(apiUrl + '/v1/admin/etablissements', data, {
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });

    return response.data;
  },

  async updateLegalDocument(slug, content) {
    const response = await axios.put(
      apiUrl + `/v1/admin/legals/${slug}`,
      { content },
      {
        headers: { Authorization: `Bearer ${getAdminToken()}` },
      },
    );

    return response.data;
  },

  async requireLegalAcceptance(slug) {
    const response = await axios.post(
      apiUrl + `/v1/admin/legals/${slug}/require-acceptance`,
      {},
      {
        headers: { Authorization: `Bearer ${getAdminToken()}` },
      },
    );

    return response.data;
  },
};
